// extracted by mini-css-extract-plugin
export default {"IconWrapper":"CartBadge_IconWrapper__npkey","InCart":"CartBadge_InCart__GD6bg","IconWrapper__Icon":"CartBadge_IconWrapper__Icon__3FZdW"};